import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { openChat } from '../../../actions/chat';
import { SubscriptionAuthorActions } from '../../../components/subscriptionBrand';
import { selectIsOfferOwnedByUser, selectIsAuthenticated } from '../../../selectors';
import { selectIsChatsEnabled, selectIsOfferChatExists } from '../../../selectors/offerChat';
import { offerPreparedPhonesSelector } from '../../../selectors/offerData/offer/offerPreparedPhonesSelector';

export const SubscriptionAuthorActionsContainer = () => {
  const isOfferChatExists = useSelector(selectIsOfferChatExists);
  const isOfferOwnedByUser = useSelector(selectIsOfferOwnedByUser);
  const phones = useSelector(offerPreparedPhonesSelector);
  const isChatsEnabled = useSelector(selectIsChatsEnabled);
  const isAuthenticated = useSelector(selectIsAuthenticated);

  const [isPhonesVisible, setIsPhonesVisible] = React.useState(false);

  const isMessageButtonVisible = isChatsEnabled && (isOfferChatExists || !isOfferOwnedByUser);

  const dispatch = useDispatch();

  const handleShowPhonesClick = React.useCallback(() => {
    setIsPhonesVisible(true);
  }, [setIsPhonesVisible]);

  const handleSendMessageClick = React.useCallback(() => {
    if (!isAuthenticated) {
      window.waitForLoginPopup?.('chats', () => {
        dispatch(openChat());

        return Promise.resolve();
      });

      return;
    }

    dispatch(openChat());
  }, [isAuthenticated, dispatch]);

  return (
    <SubscriptionAuthorActions
      isPhonesVisible={isPhonesVisible}
      phones={phones}
      isMessageButtonVisible={isMessageButtonVisible}
      messageButtonText="Написать сообщение"
      handleShowPhonesClick={handleShowPhonesClick}
      handleSendMessageClick={handleSendMessageClick}
    />
  );
};
